export default __webpack_public_path__ + "static/media/trusted-by-adidas.6851540c.png";